module.exports = __webpack_public_path__ + "static/img/b2.7a79a42c.png";